import { Box, Button, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { RouterLink } from "src/components/router-link";
import { paths } from "src/paths";
import { Seo } from "src/components/seo";

const LayoutRoot = styled("main")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexGrow: 1,
  py: "80px",
  minWidth: theme.breakpoints.values.xl,
}));

const Page = () => {
  return (
    <>
      <Seo title="401" />
      <LayoutRoot>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 6,
            }}
          >
            <Box
              alt="Not authorized"
              component="img"
              src={`${process.env.PUBLIC_URL}/static/images/error-401.png`}
              sx={{
                height: "auto",
                maxWidth: "100%",
                width: 400,
              }}
            />
          </Box>
          <Typography
            align="center"
            variant="h4"
          >
            401: 인증이 필요합니다.
          </Typography>
          <Typography
            align="center"
            color="text.secondary"
            sx={{ mt: 2 }}
          >
            잘못된 경로로 접근하거나 실수로 이 페이지에 접속하셨을 수 있습니다.
            <br />
            위쪽의 내비게이션 메뉴나 아래 버튼을 이용하여 다른 페이지로
            이동해주세요.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 6,
            }}
          >
            <Button
              component={RouterLink}
              href={paths.index}
            >
              홈으로 이동
            </Button>
          </Box>
        </Container>
      </LayoutRoot>
    </>
  );
};

export default Page;
